var _defs, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _rect5, _rect6, _rect7, _path6, _path7, _path8, _path9, _path10, _rect8, _path11, _path12, _rect9, _rect10, _rect11, _rect12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.64,86l-.91-1.57c2.61-1.51,4.09-4.5,3.69-7.44-.44-3.2-2.91-4.83-3.4-5.13l.93-1.56c.62.37,3.72,2.41,4.27,6.44.5,3.67-1.34,7.39-4.58,9.26Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.47,
    y: 99.5,
    width: 1.93,
    height: 5.67
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.34,
    y: 99.5,
    width: 1.93,
    height: 5.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.06,
    y: 73.41,
    width: 1.93,
    height: 15.43
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50,
    y: 74.39,
    width: 1.93,
    height: 10.58
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.89,71.77h-1.81v-5.06c-1.55-.1-4.22-.62-6.2-2.95-.51-.6-1.42-1.87-1.8-3.71-.73-3.47.98-6.41,1.94-7.74l-6.54-7.02c-1.04.91-2.87,2.1-5.36,2.26-1.56.1-4.53-.11-6.82-2.61-1.9-2.07-2.21-4.57-2.21-5.99h-4.82v-1.81h6.8l-.13,1.02c-.07.54-.32,3.36,1.69,5.55,1.78,1.94,4.13,2.1,5.37,2.02,2.55-.16,4.24-1.7,4.85-2.36l.66-.72,8.92,9.58-.53.62c-.47.54-2.76,3.39-2.04,6.82.3,1.44,1.01,2.44,1.41,2.91,1.96,2.31,4.85,2.36,5.68,2.33l.95-.04v6.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.07,106.39h-6.8v-1.81h4.82c0-1.42.32-3.91,2.21-5.99,2.29-2.5,5.26-2.71,6.82-2.61,2.49.16,4.32,1.35,5.36,2.26l6.54-7.02c-.96-1.33-2.67-4.27-1.94-7.74.38-1.83,1.29-3.11,1.8-3.71,1.97-2.33,4.65-2.86,6.2-2.95v-5.06h1.81v6.9l-.95-.04c-.84-.04-3.73.02-5.68,2.33-.4.47-1.11,1.47-1.41,2.91-.72,3.43,1.58,6.29,2.04,6.82l.53.62-8.92,9.58-.66-.72c-.61-.65-2.29-2.19-4.85-2.36-1.24-.08-3.59.08-5.37,2.02-2.01,2.19-1.76,5.01-1.69,5.55l.13,1.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.4,93.83c-1.98,0-3.95-.25-5.85-.75l.46-1.75c1.75.46,3.56.69,5.39.69,11.59,0,21.03-9.37,21.03-20.9,0-8.87-5.66-16.8-14.08-19.73l.6-1.71c9.15,3.18,15.29,11.8,15.29,21.44,0,12.52-10.25,22.71-22.84,22.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.02,57.12v-1.81h10.7c1.8-.11,3.35-1.3,3.96-3.03.07-.21.68-2.09-.25-3.92-.79-1.55-2.4-2.46-4.11-2.32h-.07s-10.23,0-10.23,0v-1.81h10.19c2.42-.18,4.71,1.11,5.83,3.3,1.25,2.45.51,4.88.35,5.34-.85,2.43-3.05,4.1-5.59,4.24h-.05s-10.73,0-10.73,0Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.83,
    y: 56.43,
    width: 1.84,
    height: 8.66,
    transform: "translate(61.51 121.53) rotate(180)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.93,
    y: 50.63,
    width: 1.84,
    height: 9.99,
    transform: "translate(-20.77 90.48) rotate(-90)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.01,
    y: 37.6,
    width: 1.84,
    height: 9.99,
    transform: "translate(-7.66 77.53) rotate(-90)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.98,75.45c-.18,0-.36,0-.53-.02-1.8-.17-2.18-1.12-2.26-1.52-.21-1.06-1.59-4.33-8.45-14.38-.17-.24-.28-.41-.34-.51l-.07-.13c-3.21-7.01-2.44-12.55-2.14-14.64.04-.25.08-.54.08-.62v-.17s.06-.16.06-.16c1.43-3.76,4.96-10.62,12.56-14.3,2.29-1.11,4.76-1.83,7.35-2.15h.05c3.29-.21,9.76.04,16.09,4.1,5.46,3.5,8.23,7.9,9.6,10.97,1.26,2.84,3.13,13.08,2.7,14.8-.29,1.15-1.45,1.88-2.31,2.27.91,2.1,2.34,5.51,2.34,6.43,0,8.68-4.62,9.43-6.6,9.74-.15.02-.29.05-.41.07h-.05c-.7.11-1.44.15-2.21.15-6.39,0-14.67-3.16-17.65-4.47-1.74,3.15-5.38,4.48-7.79,4.48ZM50.95,73.46c.25.15,1.17.3,2.47,0,.89-.2,3.9-1.09,5.08-4.04l.37-.91.88.44c1.77.89,12.92,5.49,19.61,4.55.14-.03.29-.05.46-.08,1.9-.31,5.07-.82,5.07-7.95-.04-.59-1.37-3.87-2.57-6.57l-.42-.95,1-.29c.76-.22,1.88-.81,2.01-1.33.23-1.1-1.26-10.62-2.59-13.63-1.27-2.85-3.84-6.92-8.92-10.18-5.87-3.77-11.88-4.02-14.96-3.83-2.38.3-4.66.96-6.76,1.98-6.95,3.37-10.24,9.64-11.6,13.18-.01.18-.04.39-.09.68-.27,1.93-.99,7.06,1.96,13.56.06.1.16.24.29.43,5.29,7.75,8.22,12.78,8.71,14.95Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.42,57.78c-3.92,0-7.11-3.19-7.11-7.11s3.19-7.11,7.11-7.11,7.11,3.19,7.11,7.11-3.19,7.11-7.11,7.11ZM59.42,45.38c-2.92,0-5.29,2.37-5.29,5.29s2.37,5.29,5.29,5.29,5.29-2.37,5.29-5.29-2.37-5.29-5.29-5.29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.48,63.35c-6.8,0-12.33-5.53-12.33-12.33s5.53-12.33,12.33-12.33,12.33,5.53,12.33,12.33-5.53,12.33-12.33,12.33ZM59.48,40.5c-5.8,0-10.52,4.72-10.52,10.52s4.72,10.52,10.52,10.52,10.52-4.72,10.52-10.52-4.72-10.52-10.52-10.52Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.94,105.88c-.14-1.67-1.25-10.29-8.89-15.8-6.45-4.65-13.33-4.2-15.98-3.79l-.28-1.79c2.88-.44,10.32-.93,17.32,4.11,8.08,5.82,9.42,14.57,9.64,17.11l-1.81.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.07,32.98c-2.6,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71ZM31.07,25.38c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9-1.3-2.9-2.9-2.9Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.91,
    y: 31.99,
    width: 1.84,
    height: 9.71,
    transform: "translate(61.67 73.69) rotate(180)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.82,53.15c-2.6,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71ZM20.82,45.54c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9-1.3-2.9-2.9-2.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.81,73.23c-2.6,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71ZM30.81,65.63c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9-1.3-2.9-2.9-2.9Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.92,
    y: 90.49,
    width: 1.84,
    height: 17.06,
    transform: "translate(-50.17 147.85) rotate(-90)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.17,
    y: 85.34,
    width: 1.84,
    height: 40.35,
    transform: "translate(-45.43 165.6) rotate(-90)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.59,
    y: 28.55,
    width: 1.93,
    height: 27.43
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.06,
    y: 41.94,
    width: 1.84,
    height: 13.15,
    transform: "translate(-16.53 80.49) rotate(-90)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.73,104.72h-1.81s.08-12.68.08-12.68l.02-.1c.31-1.35.87-2.61,1.66-3.74.95-1.36,2.22-2.51,3.69-3.32.44-.23,4.24-2.09,8.19.08,3.96,2.18,4.41,6.41,4.45,6.89v.07s.04,12.79.04,12.79h-1.81s-.04-12.75-.04-12.75c-.04-.38-.44-3.72-3.51-5.41-3.17-1.75-6.32-.14-6.46-.07-1.21.66-2.27,1.62-3.06,2.75-.64.92-1.09,1.93-1.36,3.02l-.08,12.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRms);
export default __webpack_public_path__ + "static/media/rms.2faae6186b2a5603651eecbd9d592696.svg";
export { ForwardRef as ReactComponent };